import SystemState from 'types/system';

export const systemInitialState: SystemState = {
  status: 'normal',
};
